import { render } from "./ActionsButtons.vue?vue&type=template&id=710b1cc4"
import script from "./ActionsButtons.vue?vue&type=script&lang=js"
export * from "./ActionsButtons.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__